import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AppLayout from "@/layouts/AppLayout";
import Home from "@/pages/Home";
import SosPage from "@/pages/SosPage";
import CounterPage from "@/pages/CounterPage";
import GuidesPage from "@/pages/GuidesPage";
import PassionsPage from "@/pages/PassionsPage";
import Admin from "@/pages/Admin";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sos" element={<SosPage />} />
            <Route path="/compteur" element={<CounterPage />} />
            <Route path="/guides" element={<GuidesPage />} />
            <Route path="/passions" element={<PassionsPage />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1E293B",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#F8FAFC",
          },
        }}
      />
    </div>
  );
}

export default App;
